const translations = {
  email: 'Email',
  password: 'Contraseña',
  submit: 'Iniciar sesión',
  welcome: '¡Bienvenido a Btime!',
  ssoLogin: 'Inicio de sesión SSO',
  ssoLoginRedirectMessage: 'En instantes será redirigido a la pantalla inicial.',
  loginWithGoogle: 'Iniciar sesión con Google',
  'createPasswordModal.title': '¡Para continuar, cree una nueva contraseña!',
  'createPasswordModal.subtitle': '¡Consulte los consejos para crear una contraseña segura!',
  'createPasswordModal.useFieldsBelow': 'Utilice los campos a continuación',
  'createPasswordModal.newPassword': 'Nueva Contraseña',
  'createPasswordModal.repeatPassword': 'Repita la Contraseña',
  'createPasswordModal.createAndContinue': '¡Crear y continuar!',
  'createPasswordModal.checkFieldsBelow': '¡Consulte los campos a continuación!',
  'createPasswordModal.tryAgain': 'Intentar de nuevo',
  'passwordValidations.min8Characters': 'Escriba al menos 8 caracteres',
  'passwordValidations.minOneLetter': 'Utilice al menos una letra',
  'passwordValidations.minOneNumber': 'Utilice al menos un número',
  'passwordValidations.passwordsMustMatch': 'Las contraseñas ingresadas deben coincidir',
  'passwordValidations.recommendationUppercase': 'Recomendación: Utilice una letra mayúscula',
  'passwordValidations.recommendationSpecialChars': 'Recomendación: Utilice caracteres especiales, ej.: @$%&!',
  'newPasswordForm.resettingPassword': '¡Restableciendo contraseña!',
  'newPasswordForm.confirmPassword': 'Confirmar contraseña',
  'newPasswordForm.passwordsDoNotMatch': '¡Las contraseñas ingresadas no coinciden!',
  'newPasswordForm.enterPasswordAndConfirmation': '¡Ingrese la contraseña y la confirmación para continuar!',
  'newPasswordForm.changePassword': 'Cambiar contraseña',
  'newPasswordForm.passwordSetSuccess': 'Contraseña definida con éxito',
  'newPasswordForm.passwordSetDescription':
    'Si la solicitud se hizo desde el móvil, abra la aplicación e inicie sesión con la nueva contraseña.',
  'newPasswordForm.linkNoLongerValid': 'Parece que este enlace ya no es válido',
  'newPasswordForm.requestNewPasswordChange': 'Intente solicitar un nuevo cambio de contraseña',
  'newPasswordForm.passwordNotUpdated': 'Contraseña no actualizada',
  'forgotPasswordForm.forgotPassword': '¿Olvidó la contraseña?',
  'forgotPasswordForm.requestNewPassword': 'Solicitar nueva contraseña',
  'forgotPasswordForm.requestCompleted': 'Solicitud completada',
  'forgotPasswordForm.emailBeingSent': 'Se le está enviando un correo electrónico para restablecer su contraseña.',
  'forgotPasswordForm.tryAgain': 'Intentar de nuevo',
  'authFromAdmin.title': 'Iniciar sesión desde Admin',
  'authFromAdmin.subtitle':
    'En instantes será redirigido a la pantalla inicial. Si esto no sucede, realice el proceso nuevamente desde el Admin.',
  'loginTemplate.platformTitle': 'Plataforma de Gestión Operacional',
  'loginTemplate.platformDescription':
    'Btime es una plataforma SaaS de gestión operacional que automatiza los flujos, estandariza procesos y aumenta la productividad y eficiencia de equipos internos o externos',
  'viewSwitcher.wantToLogin': '¿Desea iniciar sesión?',
  'viewSwitcher.clickHere': 'Haga clic aquí'
}

export default translations
